import { Row, Col, Container } from 'reactstrap';
import UsersTableWrapper from './table/UsersTableWrapper';

const UsersCard = () => {
  return (
    <Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">Users List</h3>
          <h3 className="page-subhead subhead">
            Here you can manage all the users under campaign.
          </h3>
        </Col>
      </Row>
      <Row>
        <UsersTableWrapper />
      </Row>
    </Container>
  );
};

export default UsersCard;
